module.exports = __webpack_public_path__ + "img/headRight3.7512d6d0.png";